import { DashCircle, IconProps } from "react-bootstrap-icons";
import { useARSContext } from "../contexts";
import { REMOVE_ARS_ITEM } from "../contexts/interface";

/**
 * Props for the RemoveArsItemButton component.
 */
export interface RemoveArsItemButtonProps extends IconProps {
  /** RFC 6901 JSON Pointer path to the item in ARSContext state */
  dataPath: string;
}

/**
 * A reusable remove button component for ARS entities.
 *
 * Renders a DashCircle icon with text-danger styling that dispatches
 * a REMOVE_ARS_ITEM action when clicked.
 *
 * @param props - Component props.
 * @param props.dataPath - RFC 6901 JSON Pointer path to the item in ARSContext state.
 * @returns A React functional component rendering the remove button.
 */
export const RemoveArsItemButton = ({
  dataPath,
  ...iconProps
}: RemoveArsItemButtonProps): React.ReactElement => {
  const { dispatch } = useARSContext();

  /**
   * Handles removing the item.
   */
  const handleRemove = (): void => {
    dispatch({
      operation: REMOVE_ARS_ITEM,
      dataPath,
    });
  };

  return (
    <DashCircle
      {...iconProps}
      id={`${dataPath.replace(/\//g, "-")}-remove-button`}
      className="text-danger"
      role="button"
      aria-label="Remove item"
      onClick={handleRemove}
    />
  );
};

RemoveArsItemButton.displayName = "RemoveArsItemButton";
